import { useContext } from "react";
import { Box, Grid, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { TeacherCard } from "./TeacherCard";
import { AuthContext } from "../../Context/AuthContext";
import { PageHeaderTitle } from "../../Utils/Component";

import ClassCard from "./ClassCard/ClassCard";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import useGetTeacherById from "../../Hooks/useGetTeacherById";
import useGetClassByTeacherId from "../../Hooks/useGetClassByTeacherId";

export default function TeacherDetail() {
  // Change Language
  const { language, t } = useContext(AuthContext);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  let teacherId = params.get("teacherId");
  const { studentData } = useGetTeacherById({ id: teacherId });
  const { classData, refetch, loading } = useGetClassByTeacherId({
    id: teacherId,
  });

  return (
    <Stack direction="column" spacing={2}>
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/teacher"}
        pageTitle={t("page_teacher")}
        detailTitle={t("page_teacher_details")}
      />
      <Box>
        <Grid item container spacing={4}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
            <TeacherCard studentData={studentData} />
          </Grid>

          {/* ====================================== Class card ================================== */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
            <Grid container spacing={3}>
              {loading ? (
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      height: 320,
                      width: "100%",
                      bgcolor: "white",
                      borderRadius: 1,
                    }}
                  >
                    <LoadingPage />
                  </Stack>
                </Grid>
              ) : classData?.length === 0 ? (
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      height: 320,
                      width: "100%",
                      bgcolor: "white",
                      borderRadius: 1,
                    }}
                  >
                    <EmptyData />
                  </Stack>
                </Grid>
              ) : (
                classData?.map((data, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={index}>
                    <ClassCard data={data} setRefetch={refetch} />
                  </Grid>
                ))
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}
